import { PageLayout } from '../../../ui/page-layout/page-layout';

export const Home = () => (
  <PageLayout>
    <p className="heading1">=)</p>
  </PageLayout>
);
